export const classes = {
  header:
    'mb-4 font-mono text-[10.5px] font-bold leading-none tracking-[0.14em] text-taupe-1 dark:text-mauve-3',
  grid: 'grid grid-cols-2 gap-x-11 max-sm:grid-cols-1',
  row: 'flex justify-between gap-[18px] border-t border-hair2 py-[11px] dark:border-hair2-dark',
  key: 'text-[13px] text-taupe-1 dark:text-mauve-3',
  value: 'text-right text-[13px] font-semibold text-taupe-3 dark:text-mauve-1',
};
